import { render } from "./contactSettings.vue?vue&type=template&id=22a5fda9&scoped=true"
import script from "./contactSettings.vue?vue&type=script&lang=js"
export * from "./contactSettings.vue?vue&type=script&lang=js"

import "./contactSettings.vue?vue&type=style&index=0&id=22a5fda9&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a5fda9"]])

export default __exports__